import { useEffect, useState } from "react"
import { shuffled } from "../helper/arrays"

const SORT_RANDOM = "random"

/**
 * Use this hook to do the final cleanup for the results of a multi format selection.
 * The collection will be empty at first when the sorting is random.
 * After the component was mounted the randomized list is limited and then returned
 * (this ensures the randomization is done on the client side).
 * @param {Array} collection The basic collection like it was delivered from the content store.
 * @param {string|Number} limitParam The result limit. If zero or not specified the collection is not limited.
 * @param {string} sorting The sort order setting from the multi format filter settings.
 * @return The cleaned up collection list, which might update after the component was rendered.
 */
export function useMultiFormatCollection(collection, limitParam, sorting) {
  if (!collection) {
    collection = [];
  }
  let limit = Number.isInteger(limitParam)
    ? limitParam
    : Number.parseInt(limitParam)
  if (!limit) {
    limit = collection.length
  }

  const [result, setResult] = useState(
    getInitialCollection(collection, limit, sorting)
  )

  useEffect(() => {
    // This ensures selecting random elements is done on the client side
    if (sorting === SORT_RANDOM) {
      setResult(shuffled(collection).slice(0, limit))
    }
  }, [])

  return result
}

const getInitialCollection = (collection, limit, sorting) => {
  if (sorting === SORT_RANDOM) {
    // items will be rendered later
    return []
  }
  let result = collection
  if (result && limit) {
    result = result.slice(0, limit)
  }
  return result
}
